import { forwardRef } from "react";
import classNames from "classnames";

import decrementSize from "../Utils/decrementSize";
import Button from "./Button";

const ButtonWithCounter = (props, ref) => {
  const {
    count,
    labelComment,
    className: providedClassName,
    buttonClassName: providedButtonClassName,
    ...passthroughProps
  } = props;

  // We can't use defaultProps for forwardRef render functions, so we handle the default
  // manually here
  const size = props.size || "md";

  const className = classNames("btn-with-counter", "d-inline-block", providedClassName);
  const buttonClassName = classNames(
    "btn",
    `btn-${size}`,
    "float-left",
    providedButtonClassName
  );

  const ariaLabel = labelComment ? { "aria-label": labelComment } : {};

  // Depending on the provided button size, with decrease from one size the
  // padding applied to the counter, since this is how button paddings are
  // designed compared to padding classes.
  //
  const counterPaddingSize = decrementSize(size);
  const counterClassName = classNames(
    "counter",
    "text-metric-sm",
    "float-left",
    `padding-${counterPaddingSize}`
  );

  return (
    <div className={className}>
      <Button {...passthroughProps} className={buttonClassName} ref={ref} />

      <div {...ariaLabel} className={counterClassName}>
        {count}
      </div>
    </div>
  );
};

export default forwardRef(ButtonWithCounter);
